import { GridRowId, GridRowModelUpdate } from "@mui/x-data-grid-pro";

export type DataGridRowUpdateHandler = (updates: GridRowModelUpdate[]) => void;

export function applyDataGridRowUpdates<RowData extends object>(
	currentRows: RowData[],
	updates: GridRowModelUpdate[],
	getRowId: (row: RowData) => GridRowId,
): RowData[] {
	const nextRows = [...currentRows];

	updates.forEach((update) => {
		const rowId = getDataGridRowUpdateId(update, getRowId);
		const currentIndex = nextRows.findIndex((row) => getDataGridRowUpdateId(row, getRowId) === rowId);

		if (update._action === "delete") {
			if (currentIndex !== -1) nextRows.splice(currentIndex, 1);
			return;
		}

		const { _action: _ignoredAction, ...rowUpdate } = update;
		const updatedRow =
			currentIndex === -1 ? rowUpdate : {
				...nextRows[currentIndex],
				...rowUpdate,
			};

		if (currentIndex === -1) nextRows.push(updatedRow as RowData);
		else nextRows[currentIndex] = updatedRow as RowData;
	});

	return nextRows;
}

function getDataGridRowUpdateId<RowData extends object>(
	row: Partial<RowData> | RowData | GridRowModelUpdate,
	getRowId: (row: RowData) => GridRowId,
): GridRowId {
	if (
		"isNewRow" in row &&
		row.isNewRow === true &&
		"__generated_id" in row &&
		typeof row.__generated_id === "string"
	) {
		return row.__generated_id;
	}

	return getRowId(row as RowData);
}
